<template>
  <div>
    <div ref="buyProfileModal" class="modal modal-v modal-v--normal fade show" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-body d-flex flex-column align-items-center justify-content-md-center justify-content-start mt-4 mt-md-0 text-center">
            <h2 class="title title--medium mb-5">{{ trans.get('pages:members.buy_profile_access_modal.header') }}</h2>

            <img v-if="avatarUrl" class="profile-show__modal-avatar" :src="avatarUrl" alt="">
            <img v-else class="profile-show__modal-image mb-3" src="/img/viluu/background/coins.png" alt="coins">
            <p class="desc desc--lightgrey my-3">{{ trans.get('pages:members.buy_profile_access_modal.slogan') }}</p>
            <div class="title title--big">
              <span class="js-price">{{ payment_profile_unlock }}</span>
              <i class="demo-icon icon-n-lova-coins"></i>
            </div>
            <button
              type="button"
              class="button button__fill mt-3 mb-3 "
              v-on:click="unlock"
            >
              {{ trans.get('pages:members.buy_profile_access_modal.unlock_button') }}
            </button>
            <div v-if="false" class="checkbox-standard pull-left">
              <label>
                <input type="checkbox" v-model="agreement">
                <span class="checkbox-standard__box checkbox-standard__box--small mr-2"></span> <span class="desc desc--small">
                  {{ trans.get('pages:members.buy_profile_access_modal.i_agree_label') }}
                </span>
              </label>
            </div>

            <button type="button" class="button button__link button__link--underline mt-3 " data-dismiss="modal">
              {{ trans.get('pages:members.buy_profile_access_modal.close_button') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BuyProfileModal',
  components: {},
  props: {},
  data() {
    return {
      agreement: true,
      open: false,
      form: {},
      profileId: null,
      avatarUrl: null,
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
      isPaymentApproved: 'isPaymentApproved',
    }),
    payment_profile_unlock: function () {
      return window.globals.settings_payment_profile_unlock;
    }
  },
  watch: {
    open(val) {
      if (val) {
        if (this.payment_profile_unlock > (this.user.coins + this.user.free_coins)) {
          this.open = false;
          this.$eventHub.$emit('EventPopupModalOpen', this.globals.actions.ACTION_NOT_ENOUGH_COINS);
          return false;
        }

        if (this.isPaymentApproved(window.globals.user.payment_approval_profile)) {
          this.unlock();
        } else {
          $(this.$refs.buyProfileModal).modal('show');
        }
      } else {
        $(this.$refs.buyProfileModal).modal('hide');
        this.profileId = null;
        this.form = {};
      }
    },
  },
  methods: {
    unlock() {
      let form = this.form;
      form.agreement = this.agreement;
      const isCrypt = ('' + this.profileId).startsWith('V');

      axios
        .post(zRoute(isCrypt ? 'ajax.profiles.unlock.store' : 'ajax.profiles.store', this.profileId), form)
        .then(response => {
          const data = response.data.data;
          data.profileId = this.profileId;
          this.$eventHub.$emit('FreshProfile', data);
          this.open = false;
        })
        .catch(error => {
          if (error.response.data.reason === this.globals.actions.ACTION_NOT_ENOUGH_COINS) {
            this.open = false;
          }

          if (error.response.data.reason === this.globals.actions.ACTION_PROFILE_ALREADY_PAID) {
            this.open = false;
          }

          if (error.response.data.reason === this.globals.actions.ACTION_PAYWALL_PAYMENT) {
            this.open = false;
          }
        });
    },
  },
  mounted() {
    let vm = this;

    this.$eventHub.$on('BuyProfileModalOpen', ({ profileId, form, avatarUrl }) => {
      this.open = false;
      this.profileId = profileId;
      this.form = form;
      this.avatarUrl = avatarUrl;

      this.$nextTick(() => {
        this.open = true;
      });
    });

    $(this.$refs.buyProfileModal).on('hidden.bs.modal', function (e) {
      vm.open = false;
    });
  }
};
</script>

<style scoped>

</style>
